import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

const useStyle = makeStyles((theme: Theme) => ({
  gridListWrapper: {
    '&&': {
      [theme.breakpoints.down('tablet')]: {
        rowGap: SPACES.s,
        columnGap: SPACES.s,

        justifyContent: 'center',
      },
      [theme.breakpoints.up('tablet')]: {
        rowGap: '2.5rem',
        columnGap: SPACES.xxxxxl,
      },
    },
  },
}))

export default useStyle
